export default __webpack_public_path__ + "assets/ico_trash-19fe45ff.svg";